module.exports = __webpack_public_path__ + "img/max-file-content-search.212c8fcf.svg";